import { SidebarFooterLinkWrapper } from './MainSidebar/SidebarStyles';
import styled from 'styled-components';
import theme from '@theme';
import { useTranslation } from 'react-i18next';
import { Light } from '../../images/sidebar';
import { useNavigate } from 'react-router-dom';

const CustomBetaFooter = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <SidebarFooterLinkWrapper>
      <StyledCustomBetaFooter>
        <div className="footer_wrapper">
          <div className="badge_wrapper">
            <img src={Light} alt="icon" />
          </div>
          <div className="text_wrapper">
            <div
              className="link"
              onClick={(e) => {
                e.preventDefault();
                navigate('/contact');
              }}
            >
              {t('component.layout.customBetaFooter.contact', 'If you encounter any problem')}
            </div>
          </div>
        </div>
      </StyledCustomBetaFooter>
    </SidebarFooterLinkWrapper>
  );
};

export default CustomBetaFooter;
const StyledCustomBetaFooter = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0.65rem;
  gap: 12px;

  background: ${theme.palette.blue[50]};

  border-bottom: 1px solid ${theme.palette.grey[100]};
  border-radius: 6px;

  .footer_wrapper {
    display: flex;
    flex-direction: column;

    .badge_wrapper {
      display: flex;
      margin-bottom: 10px;
    }

    .text_wrapper {
      font-weight: ${theme.fonts.weight.medium};
      font-size: ${theme.fonts.size.xs};
      line-height: ${theme.fonts.spacing.sm};
      text-align: left;

      color: ${theme.palette.blue[700]};

      .link {
        font-weight: ${theme.fonts.weight.medium};
        font-size: ${theme.fonts.size.xs};
        line-height: ${theme.fonts.spacing.sm};
        color: ${theme.palette.blue[500]};

        text-align: left;
        cursor: pointer;
      }
    }
  }
`;
